import { render, staticRenderFns } from "./CustomerListCreate.vue?vue&type=template&id=10fa9719"
import script from "./CustomerListCreate.vue?vue&type=script&lang=js"
export * from "./CustomerListCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10fa9719')) {
      api.createRecord('10fa9719', component.options)
    } else {
      api.reload('10fa9719', component.options)
    }
    module.hot.accept("./CustomerListCreate.vue?vue&type=template&id=10fa9719", function () {
      api.rerender('10fa9719', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/customer/views/CustomerListCreate.vue"
export default component.exports